'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.createThroughAgentClass = createThroughAgentClass;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hasDiff = require('./hasDiff');

var _hasDiff2 = _interopRequireDefault(_hasDiff);

var _hasComplex = require('./hasComplex');

var _hasComplex2 = _interopRequireDefault(_hasComplex);

var _throughAgent = require('./throughAgent');

var _throughAgent2 = _interopRequireDefault(_throughAgent);

var _Item = require('./Item');

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createThroughAgentClass(area, key, syncUpdate) {
  var _class, _temp, _initialiseProps;

  var ThroughAgent = (_temp = _class = function (_React$Component) {
    _inherits(ThroughAgent, _React$Component);

    function ThroughAgent(props) {
      _classCallCheck(this, ThroughAgent);

      var _this = _possibleConstructorReturn(this, (ThroughAgent.__proto__ || Object.getPrototypeOf(ThroughAgent)).call(this));

      _initialiseProps.call(_this);

      _this.configureItem(props);
      _this.state = {
        configureItem: _this.configureItem,
        props: {}
      };
      return _this;
    }

    _createClass(ThroughAgent, [{
      key: 'render',
      value: function render() {
        return null;
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(props, state) {
        if ((0, _hasDiff2.default)(props, state.props)) {
          state.configureItem(props);
          return _extends({}, state, { props: props });
        }
        return null;
      }
    }]);

    return ThroughAgent;
  }(_react2.default.Component), _class.propTypes = _defineProperty({}, area, _propTypes2.default.object), _initialiseProps = function _initialiseProps() {
    this.configureItem = syncUpdate === undefined ? function (props) {
      var notused = props[area],
          data = _objectWithoutProperties(props, [area]);

      var syncUpdate = !(0, _hasComplex2.default)(data);
      props[area].item(_react2.default.createElement(_Item2.default, data), syncUpdate);
    } : function (props) {
      var notused = props[area],
          data = _objectWithoutProperties(props, [area]);

      props[area].item(_react2.default.createElement(_Item2.default, data));
    };
  }, _temp);


  ThroughAgent.displayName = 'ThroughAgent.' + area;

  return ThroughAgent;
}

// this function with *two* params was documented and may be in use
var throughAgentFactory = function throughAgentFactory(area, key) {
  var syncUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;


  if (!(typeof area === 'string' || area instanceof String)) {
    throw new Error("type error: throughAgentFactory(area:string, key:string|function)");
  }

  var ThroughAgent = createThroughAgentClass(area, key, syncUpdate);

  return (0, _throughAgent2.default)(area, key)(ThroughAgent);
};

exports.default = throughAgentFactory;